import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { FarmService } from 'src/app/services/farm-service.service';
import Swal from 'sweetalert2';
import { refCount } from 'rxjs/operators';
import * as moment from 'moment';
import { format } from 'path';

declare var $: any;

@Component({
  selector: 'smart-create-plot',
  templateUrl: './create-plot.component.html',
  styleUrls: ['./create-plot.component.css']
})
export class CreatePlotComponent implements OnInit {


  constructor(
  ) {
  }

  ngOnInit() {
   
  }

  

}
